import React from 'react';
import BaseIntegration from 'screens/Integrations/components/BaseIntegration';
import { INTEGRATIONS } from 'screens/Integrations/helpers/constants';
import StepSelector from '../StepSelector';
import { PROPERTIES_SELECTION_STEP } from '../../helpers/constants';

const progressBarSteps = [
  {
    caption: 'Select Crop Seasons'
  },
  {
    caption: 'Select Properties'
  },
  {
    caption: 'Select Products'
  },
  {
    caption: 'Enter Field Details'
  },
  {
    caption: 'Review and Submit'
  }
];

const BaseCalAgIntegration = () => {
  return (
    <BaseIntegration
      integrationType={INTEGRATIONS.calAgPermits}
      progressBarSteps={progressBarSteps}
      selectPropertiesStep={PROPERTIES_SELECTION_STEP}
      StepSelector={StepSelector}
    />
  );
};

export default BaseCalAgIntegration;
